(function () {
    'use strict';

    function itemTile($timeout, $document, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/itemTile.html',
            transclude: true,
            scope: {
                mode: '@?',
                imageUrl: '=',
                description: '=',
                badgeContext: '=',
                popoverConfig: '='
            },
            link: function (scope, element, attrs) {
                function setNoteBadgeData() {
                    scope.showBadge = true;
                    var comments = scope.badgeContext.ProjectUnderwritingNotes.filter(function (note) {
                        return !note.IsDeleted;
                    });
                    scope.badgeImage = comments.length == 0 ? '/images/add_comment_plus_white.png' : '/images/add_comment_white.png';
                    scope.badgeText = comments.length === 0 ? '' : comments.length;
                }

                if (scope.mode === 'comments') {
                    setNoteBadgeData();
                    var events = ["noteSaved", "noteRemoved", "noteResolved"];
                    events.forEach(function (event) {
                        $rootScope.$on(event, function (event, args) {
                            if (args === scope.badgeContext.Path) {
                                setNoteBadgeData();
                            }
                        });
                    });

                    $rootScope.$on('jumpToComment', function (event, args) {
                        if (args.path === scope.badgeContext.Path) {
                            var button = $(element).find('.item-tile-image-button');
                            button.click();
                        }
                    });
                }
                if (scope.mode === 'readonly') {
                    scope.showBadge = false;
                }

                if (scope.mode === 'addNew') {
                    scope.showBadge = false;
                }
            }
        };
    }

    itemTile.$inject = ['$timeout', '$document', '$rootScope'];

    angular.module('ecap.common').directive('itemTile', itemTile);
})();